import React, {ReactElement} from 'react';
import settingIconSrc from '@assets/images/medops/setting.svg';

const SettingIcon = (props: any): ReactElement => {
  return <img src={settingIconSrc} {...props} />;
};
export default SettingIcon;
